import React from 'react';
import { configData } from "../config";
import { hasStaffSidebar } from './SalespersonSidebar';
import './classes/QuickLinks.css';

// The live site's "Quick Links" block in the right column of the pages with the general quick form
// (degree pages, course pages outside /courses), under the form, for signed-in staff: Dashboard
// Home, Manage My Profile, My Account and People. The links go to this
// site's pages, as the staff sidebar's (SalespersonSidebar) do, for the same roles.
const QuickLinks = ({ roles }) => {
    if (!hasStaffSidebar(roles)) return null;
    const isAdministrator = roles.includes(configData.ROLE_ADMINISTRATOR);
    const isSalesperson = roles.includes(configData.ROLE_SALES_PEOPLE);
    const agencyDomain = [configData.RSMWW_AGENCY_DOMAIN, configData.RSMWW_AGENCY_DOMAIN1].includes(window.location.host);
    return (
        // Headed like the Success Stories block under it
        <div className="course-success-box quick-links-block">
            <h2 className="success-title">Quick Links</h2>
            <ul className="quick-links-list">
                {(isAdministrator || isSalesperson) && <li><a href={"/user/" + localStorage.getItem('uid')}>Dashboard Home</a></li>}
                <li><a href={"/user/" + localStorage.getItem('drupal_uid') + "/edit"}>Manage My Profile</a></li>
                {isAdministrator && <li><a href={agencyDomain ? "/my_agents_account" : "/my_scouts_account"}>My Account</a></li>}
                {isAdministrator && <li><a href="/manage/people">People</a></li>}
            </ul>
        </div>
    );
};

export default QuickLinks;
